import type { ReactNode, Ref } from "react";

interface DetailSectionProps {
    title: string;
    children: ReactNode;
    // Makes the heading a programmatic focus target (tabIndex -1), e.g. where
    // a dialog returns focus when its opener in this section is gone.
    headingRef?: Ref<HTMLHeadingElement>;
}

export const DetailSection = ({
    title,
    children,
    headingRef,
}: DetailSectionProps) => (
    <section className="rounded-lg border border-base-300 bg-base-100 p-5">
        <h2
            ref={headingRef}
            tabIndex={headingRef ? -1 : undefined}
            className="mb-3 text-lg font-bold"
        >
            {title}
        </h2>
        {children}
    </section>
);
